import React from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { NavLink as Link } from 'react-router-dom';
import Icon from '../../../../components/Icon/Icon';
import { injectIntl, FormattedMessage } from 'react-intl';

class ProfileNavItem extends React.Component {
  render() {
    const icon = () => {
      switch (title) {
        case 'Profile':
          return 'user-2';
        case 'Payment Data':
          return 'card';
        case 'Security':
          return 'lock';
        case 'Notifications':
          return 'kma-announcement';
        case 'Contract work':
          return 'network';
        case 'Password':
          return 'dots-2';
        case 'Social Networks':
          return 'network';
        case 'Contracts':
          return 'folder';
        case 'API key':
          return 'kma-key';
        default:
          return 'kma-menu';
      }
    };
    const { path, title, translated } = this.props;

    return (
      <Nav vertical>
        <NavItem>
          <NavLink to={path} tag={Link}>
            <div className="profile-nav-item">
              <Icon type={icon()} tag="i" />
              <span className="text-dark">
                <FormattedMessage className="text-dark" id={`${translated}.theme_3`} />
              </span>
            </div>
          </NavLink>
        </NavItem>
      </Nav>
    );
  }
}

export default injectIntl(ProfileNavItem);
